import { render, staticRenderFns } from "./feed_back_tag_dialog.vue?vue&type=template&id=597464f1"
import script from "./feed_back_tag_dialog.vue?vue&type=script&lang=js"
export * from "./feed_back_tag_dialog.vue?vue&type=script&lang=js"
import style0 from "./feed_back_tag_dialog.vue?vue&type=style&index=0&id=597464f1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports